// extracted by mini-css-extract-plugin
export var inputContainer = "_s0-0";